import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Keyable from '../../../../../types/keyable';

interface AddressState {
  placeDescription?: string | undefined;
  placeId?: string;
  latitude: number;
  longitude: number;
}

export interface GeneralInfoLocationFormState extends Keyable {
  address?: AddressState;
  name: string;
}

const initialState: GeneralInfoLocationFormState[] = [];
export const generalInfoLocationsSlice = createSlice({
  name: 'generalInfoLocations',
  initialState,
  reducers: {
    setGeneralInfoLocationsStateDefault: () => {
      return initialState.slice();
    },
    submitGeneralInfoLocations: (state, action: PayloadAction<GeneralInfoLocationFormState[]>) => {
      return action.payload;
    },
  },
});

export const { setGeneralInfoLocationsStateDefault, submitGeneralInfoLocations } = generalInfoLocationsSlice.actions;

export default generalInfoLocationsSlice.reducer;
